import { useMemo } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router'
import { CssBaseline } from '@mui/material'
import { Navigation } from '~/components'
import ThemeProvider from '~/theme/ThemeProvider'
// import NotFoundError from './NotFoundError'

const RouteBoundary = () => {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    // if (error.status === 404) {
    //   return <NotFoundError />
    // }
    /*     if (error.status === 401) {
      return <AccessDeniedError />
    }

    if (/5\d\d/.test(error.status.toString())) {
      return <ServerError />
    } */
  }

  const content = useMemo(() => {
    if (isRouteErrorResponse(error) && error.status === 404) {
      return 'Not Found!'
    }
    return (
      <div>
        <div>Sorry, an unexpected error has occurred.</div>
        <div>
          <i>{error.statusText || error.message}</i>
        </div>
      </div>
    )
  }, [error])

  return (
    <ThemeProvider>
      <CssBaseline />
      <Navigation />
      <div className="grow grid">{content}</div>
    </ThemeProvider>
  )
}

export default RouteBoundary
